export const RoundTrip = 1;
export const OneWay = 2;
export const MultiDestination = 3;